import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export function DisconnectedOverlay() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[5000] flex flex-col items-center justify-start">
      <div className="mt-4 flex items-center justify-center gap-4 rounded-lg border border-[#2E3835] bg-card2 p-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#2E3835]">
          <WifiOff className="h-6 w-6 animate-pulse text-gray-600" />
        </div>
        <div>
          <h1 className="font-bold text-white">No Internet detected</h1>
          <p className="text-gray-300">Please check your internet connection and try again.</p>
        </div>
      </div>
    </div>
  );
}
